export class Menu {

  private static doc: HTMLElement;


    public static init() {
        document.addEventListener('DOMContentLoaded', Menu.onDocumentLoaded, false);
        Menu.doc = document.documentElement;
        var mainMenuWrapper = document.getElementById("mainNavMenuWrapper");
    }
    
    private static onDocumentLoaded() {
  
      Menu.initMouseEvents();
      Menu.highlightActiveMenuItem();
      Menu.removeEmptySubMenu();
    }

    private static initMouseEvents() {
      
    }

    private static highlightActiveMenuItem() {
      var windowLocation = window.location.toString();
      var mainItems = document.querySelectorAll("._mainMenuItem a");
      var subMenuList = document.getElementsByClassName("_subMenu");
      /*console.log("All main items:", mainItems);
      console.log("All sub items:", subMenuList);

      if(windowLocation[windowLocation.length -1] != '/'){
        //var $href = subMenuList.item(x).href;
        windowLocation += '/';
      }
      else{
        for(var i = 0; i < mainItems.length; i++){
        //  var doHighlight = items[i].getAttribute("href").includes(windowLocation)
          if(mainItems[i].getAttribute("href") == windowLocation){
            mainItems[i].parentElement.classList.add("active");
          }
        }
      }
       console.log(windowLocation);


      */
      //Change color of main menu entry 
      if(windowLocation[windowLocation.length -1] != '/'){
          //var $href = subMenuList.item(x).href;
          windowLocation += '/';
        }
        else{
          for(var i = 0; i < mainItems.length; i++){
          //  var doHighlight = items[i].getAttribute("href").includes(windowLocation)
            if(mainItems[i].getAttribute("href") == windowLocation){
              mainItems[i].parentElement.classList.add("active");
            }
          }
        }

       for(var i = 0; i < subMenuList.length; i++) {
        var subMenuLinks = subMenuList.item(i).getElementsByTagName('a');

        for(var x =0; x<subMenuLinks.length; x++){
          var href = subMenuLinks.item(x).href;
          if(href[href.length -1] != '/'){
            href += '/';
          }
          
          if(href == windowLocation){
            subMenuLinks.item(x).classList.add("active");									
            var mainMenuItemLink = subMenuList.item(i).parentElement.getElementsByTagName('a')[0];
            mainMenuItemLink.parentElement.classList.add('active');
          }
        }
       }
    }

    private static removeEmptySubMenu(){
      var mainMenuItems = document.getElementsByClassName("_mainMenuItem");
      for(var x =0; x<mainMenuItems.length; x++){
          var submenuItems = mainMenuItems[x].getElementsByClassName("_subMenu");
          for(var y =0; y<submenuItems.length; y++) {
            if(submenuItems.item(y).innerHTML == "") {
              submenuItems.item(y).parentNode.removeChild(submenuItems.item(y))
            }
          }
      }

    }
}
     
